import { styled } from 'styled-components';

export const MobileText = styled.span`
  @media screen and (min-width: 768px) {
    display: none;
  }
`;

export const DesktopText = styled.span`
  display: none;

  @media screen and (min-width: 768px) {
    display: unset;
  }
`;
